import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
/* eslint-disable import/named */
import { MultiValue } from 'react-select';

import { useSpdCore } from '../../../common/hooks/useSpdCore';

import MultiSelectSortable, { ReactSelectOption } from './SortableSelect';

export interface RegisterMultiSelectorProps {
  readOnly?: boolean;
  selectedRegisterIds?: string[];
  onChange?: (options: MultiValue<ReactSelectOption>) => void;
}

export default (props: RegisterMultiSelectorProps) => {
  const spd = useSpdCore();
  const [registers, setRegisters] = useState<ReactSelectOption[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<ReactSelectOption[]>(
    [],
  );
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    spd.registers
      .getAll()
      .then(registers => {
        if (mounted) {
          const result = registers
            .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
            .map(
              r =>
                ({
                  value: r.id,
                  label: r.name,
                }) as ReactSelectOption,
            );
          setRegisters(result);
          setReady(true);
        }
      })
      .catch(error =>
        console.log(`Wystąpił problem z pobraniem rejestrów. ${error}`),
      );

    return () => {
      mounted = false;
    };
  }, [spd.registers]);

  useEffect(() => {
    if (props.selectedRegisterIds && registers.length > 0) {
      const selected = registers.filter(r =>
        props.selectedRegisterIds?.includes(r.value),
      );
      setSelectedOptions(selected);
    } else {
      setSelectedOptions([]);
    }
  }, [props.selectedRegisterIds, registers]);

  return ready ? (
    <MultiSelectSortable
      options={registers}
      defaultValue={selectedOptions}
      onChange={options => props.onChange && props.onChange(options)}
    />
  ) : (
    <Skeleton />
  );
};
